import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import { Popover, PopoverActionsBar } from '@progress/kendo-react-tooltip';
import React, { useRef, useState } from 'react';
import { RadioButton } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';

function ProductCard({ product, interval, numberOfSeats, selected, onSelect, selectedOption, onProductCardChange, onProductCardSelectionChange }) {

    const anchor = useRef(null);
    const [show, setShow] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [isBtnHover, setIsBtnHover] = useState(false);

    const { t } = useTranslation("payment/product_card", { useSuspense: false })

    const handleMouseEnter = () => {
        setIsHover(true);
    };
    const handleMouseLeave = () => {
        setIsHover(false);
    };

    const handleMouseBtnEnter = () => {
        setIsBtnHover(true);
    };
    const handleMouseBtnLeave = () => {
        setIsBtnHover(false);
    };

    function getPrice() {
        if (!product.price) return 0;
        if (interval === "monthly") return product.price.monthly.amount;
        return (product.price.annually.amount / 12).toFixed(2);
    }

    function isFreeProduct() {
        return product.isFree;
    }

    function onSelectEnterprise() {
        window.open('https://www.codelessone.com/contact-us/', '_blank', 'noopener')
    }

    return (
        <div className='col-3 align-items-stretch mb-5'>
            <div className='text-center'>
                {
                    selected && !isFreeProduct() && product.name && product.name !== "Enterprise" ?
                        <button onClick={onSelect} className="btn btn-link p-0">
                            Buy more seats
                        </button>
                        :
                        <>&nbsp;</>
                }
            </div>
            <Popover
                show={show}
                anchor={anchor && anchor.current}
                position={"top"}
                animate={false}>
                <span>
                    {t("popover_message")}
                    <span className='mx-1'>
                        {product.name}
                    </span>
                    {t("popover_message_end")}
                </span>
                <br />
                <span>
                    {t("upgrade_message")}
                </span>
                <PopoverActionsBar layout="end">
                    <button onClick={() => setShow(false)} className='btn btn-primary'>
                        {t("got_it")}
                    </button>
                </PopoverActionsBar>
            </Popover>
            <div className={`text-center  hoverRadio  ${product.name} ${product.name === "Enterprise" ? "mt-4 pt-3" : "mb-3"}`}>
                {product.name && product.name !== "Enterprise" && <input
                    type="radio"
                    name='choosePlan'
                    checked={selectedOption && selectedOption === product.name ? true : false}
                    style={{ color: selectedOption && selectedOption === product.name ? product.color : "#C9C9C9" }}
                    onChange={(e) => onProductCardSelectionChange(product.name)}
                />}
            </div>
            <Card className="custom-card"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => onProductCardSelectionChange(product.name)}
                style={{
                    border: (selectedOption && selectedOption === product.name) || isHover ? `1px solid ${product.color}` : "1px solid #C9C9C9",
                    background: selectedOption && selectedOption === product.name ? product.bgColor : "#FFFFFF"
                }}
            >
                {/* <div
                    className="text-center w-100 py-3"
                    style={{
                        backgroundColor:
                            (product.price && product.price.unit_amount === 0)
                                ? "#FFF"
                                : product.color,
                        color: "#FFFFFF",
                        borderTopLeftRadius: ".6rem",
                        borderTopRightRadius: ".6rem",
                        borderBottomLeftRadius: "0",
                        borderBottomRightRadius: "0",
                    }}
                >
                    {product.inOffer ? (
                        <>Limited time offer.</>
                    ) : <div>&nbsp;</div>}
                </div> */}
                <CardTitle className="ps-4 pe-5 me-3 ms-1">
                    {
                        product.name === "Pro" && (
                            <div>
                                <span className='float-right most-pop'>
                                    {t("best_value")}
                                </span>
                            </div>
                        )
                    }
                    <h4 className='mt-2 pt-5'
                        style={{
                            color: product.color,
                            fontSize: "22px",
                            fontWeight: 600
                        }}
                    >
                        {product.name}
                    </h4>


                    <div className='rate1 pt-1'>
                        {product.cardDescription}
                    </div>
                    {
                        product.name === "Enterprise" ?
                            <div className="d-flex w-100 align-items-baseline enter mt-4 mb-5">
                                <a style={{ color: product.color, fontSize: "21px", fontWeight: "500" }} href='https://www.codelessone.com/contact-us/' target="_blank" rel="noreferrer">Contact Sales</a>
                            </div>
                            :
                            <div className="d-flex w-100 align-items-baseline mt-4 mb-2">
                                <h2
                                    className={`text-${product.isDiscounted
                                        ? "muted"
                                        : "dark"
                                        }`}
                                    style={{
                                        textDecoration:
                                            product.isDiscounted
                                                ? "line-through"
                                                : "none",
                                    }}
                                >
                                    {product.price && <span style={{ color: product.color, fontSize: "24px", fontWeight: "500" }}><span className='font-size-4'>$</span>&nbsp;{getPrice()}</span>}&nbsp;
                                </h2>
                                <span
                                    style={{
                                        fontSize: "14px",
                                        color: "#888EA1"
                                    }}>
                                    {getPrice() === 0
                                        ? "Forever"
                                        : " seat/mo"
                                    }
                                </span>
                                {product.isDiscounted && (
                                    <>
                                        &nbsp; &nbsp;
                                        <h1
                                            className={`text-dark`}

                                        >
                                            ${
                                                product.getDiscountedPrice(getPrice())
                                            }
                                        </h1>
                                        &nbsp;
                                        <span
                                            style={{
                                                fontSize: "13px",
                                                color: "#888EA1"
                                            }}>
                                            {product.price[interval] === 0
                                                ? "Forever"
                                                : " seat/mo"}
                                        </span>
                                    </>
                                )}
                            </div>
                    }
                </CardTitle>
                <CardBody className="p-4 pb-3 pt-2 ms-1">
                    <div className='card-border'>
                        <table>
                            <thead>
                                <tr>
                                    <th className="pt-3">
                                        {product.includesOtherProductProperties && (
                                            <p
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    color: "#000000"
                                                }}
                                            >
                                                {t("includes_product", { product: product.name })}
                                            </p>
                                        )}
                                    </th>
                                </tr>
                            </thead>
                            <div className={product.name === "Free" ? "free" : ""}>
                                <tbody>
                                    {product.propertiesShownInCard?.map(
                                        (property, index) => (
                                            <tr
                                                className="d-flex justify-content-between"
                                                key={index}
                                            >
                                                <td>
                                                    <div>
                                                        <span
                                                            style={{
                                                                color: "#212121",
                                                                fontSize: "13px",
                                                                lineHeight: "25px",
                                                            }}
                                                        >
                                                            {property}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </div>
                        </table>
                    </div>
                </CardBody>

                <div className="w-100 d-flex justify-content-center btn-position font-size-2"
                    onMouseEnter={handleMouseBtnEnter}
                    onMouseLeave={handleMouseBtnLeave}
                >
                    {selected ? (

                        <button
                            ref={anchor}
                            onClick={(e) => {
                                if (product.name === "Free") {
                                    setShow(!show);
                                }
                                else if (product.name === "Enterprise") {
                                    onSelectEnterprise();
                                }
                                else {
                                    onSelect(e);
                                }
                            }}
                            style={{
                                border: `2px solid ${product.color}`,
                                color: isBtnHover ? product.textColor : product.color,
                            }}
                            className='btn-product'
                        >
                            {product.name !== "Enterprise" ? t("current_plan") : t("contact_sales")}
                        </button>




                    ) : (
                        <button
                            className='btn-product'
                            style={{
                                border: `2px solid ${product.color}`,
                                color: isBtnHover ? product.textColor : product.color,
                            }}


                            onClick={(e) => {
                                if (product.name === "Enterprise") {
                                    onSelectEnterprise();
                                }
                                else {
                                    onSelect(e);
                                }
                            }}
                        >
                            {product.name !== "Enterprise" ? t("select_plan") : t("contanct_sales")}
                        </button>
                    )}
                </div>
            </Card>
        </div>
    )

};

export default ProductCard;